/* Homebound button — cursor-origin hover fill.

   The circle behind the label grows from where the pointer crossed the
   button's edge and collapses back toward where it left, matching
   databarracks.com. CSS alone can't do this: it has no idea where the
   pointer is, so it can only ever animate from a fixed point.

   All this does is publish three custom properties the stylesheet reads:
     --hb-btn-x / --hb-btn-y  the pointer position, relative to the button
     --hb-btn-r               distance from there to the furthest corner,
                              i.e. the radius that just covers the pill

   Delegated from the document, so buttons rendered later (cart drawer,
   quick-add, section re-renders in the theme editor) work without rebinding.
*/
(function () {
  'use strict';

  var SELECTOR = '.hb-btn';

  /* The circle has to reach the corner furthest from where the pointer is,
     otherwise the far end of the pill never fills. */
  function radiusToFurthestCorner(x, y, w, h) {
    return Math.max(
      Math.hypot(x, y),
      Math.hypot(w - x, y),
      Math.hypot(x, h - y),
      Math.hypot(w - x, h - y)
    );
  }

  function setOrigin(button, event) {
    var rect = button.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    var x = event.clientX - rect.left;
    var y = event.clientY - rect.top;

    button.style.setProperty('--hb-btn-x', x + 'px');
    button.style.setProperty('--hb-btn-y', y + 'px');
    button.style.setProperty(
      '--hb-btn-r',
      radiusToFurthestCorner(x, y, rect.width, rect.height) + 'px'
    );
  }

  /* pointerenter/leave rather than mouseenter/leave so pens behave too.
     Touch never fires these, which is what we want — a tap should just
     follow the link, not play an animation on the way out. */
  document.addEventListener(
    'pointerover',
    function (event) {
      if (event.pointerType === 'touch') return;
      var button = event.target.closest && event.target.closest(SELECTOR);
      /* pointerover also fires moving between the button's own children;
         only re-aim when the pointer actually came from outside it. */
      if (!button || button.contains(event.relatedTarget)) return;
      setOrigin(button, event);
    },
    true
  );

  document.addEventListener(
    'pointerout',
    function (event) {
      if (event.pointerType === 'touch') return;
      var button = event.target.closest && event.target.closest(SELECTOR);
      if (!button || button.contains(event.relatedTarget)) return;
      /* Re-aim at the exit point before the circle shrinks. Safe to move it
         mid-state because it is at full scale here — it covers the button
         from either origin, so the reposition itself is invisible. */
      setOrigin(button, event);
    },
    true
  );
})();
